import React from "react";
import Donors from "./Donors";
import {getDatas, getUtms, makeLogo, setTable, updateCartNumber} from "../extras/Actions";

export default class ListOfDonors extends React.Component{
    componentDidMount() {
        setTable()
        getUtms();
        if (window.location.href.includes("donors") && localStorage.getItem("donors") !== null){
            makeLogo()
        }else{
            getDatas()
        }
        updateCartNumber()
    }

    render() {
        return (
            <div className="ListOfDonors">
                <h3>
                    Gracias por sus regalos
                </h3>
                <Donors/>
            </div>
        );
    }
}